import { Log } from 'ng2-logger';
import React, { Dispatch } from 'react';
import { connect } from 'react-redux';
import { Common } from '../../core/common';
import { IAction, IAppState } from '../../models/action/core';
import * as ForumActions from '../../store/actions/forum';
import { Confirm } from '../notification/main';
import Translator from '../../core/i18n';
import { IProcessingForumMessage } from '../../models/components/processing-forum-message';
import { MessageDeletionType } from '../../models/enums/MessageDeletionType';

const T = Translator.create();
const _logger = Log.create('Processing Activity');
let _common: Common;
class MessageProcessing extends React.Component<IProcessingForumMessage, any> {
    constructor(props: any) {
        super(props);
        _common = new Common();
    }

    public deleteMessageOnClick = () => {
        Confirm.setConfirm('normal', this.deleteMessageConfirmClick, T.t('r_gen_delete_message_question'), null);
    };

    deleteMessageConfirmClick = () => {
        this.props.dispatch(
            ForumActions.deleteAnswerMessageGetAction(
                this.props.threadId, this.props.updateMessageId, MessageDeletionType.SingleDelete, this.props.forumSubject,
                this.callback
            )
        );
    };

    public onClickItems(val: string) {
        switch (val) {
            case 'Edit': {
                if (this.props.updateMessageId) {
                    this.props.dispatch(ForumActions.getMessageData(this.props.threadId, this.props.updateMessageId, this.props.forumSubject, '', 'get', this.callback));
                }
                break;
            }
            default:
                break;
        }
    }

    callback = (val: string) => {
        switch (val) {
            case 'Edit': {
                if (this.props.modalTrigger && this.props.updateMessageId) {
                    this.props.modalTrigger(this.props.updateMessageId);
                }
                break;
            }
            default:
                break;
        }
    };

    public render() {
        return (
                <div className="dropdown" style={{float: "inline-end"}}>
                <a data-toggle="dropdown" href="javascript:;" aria-expanded="false" style={{ marginInlineStart: 187 }}>
                        <img src={_common.GetDefaultIcons('dots')} alt="Dots" />
                    </a>
                    <div
                        className="dropdown-menu shadow"
                        aria-labelledby="dropdownMenuButton"
                        x-placement="bottom-start"
                        style={{
                            position: 'absolute',
                            transform: ' translate3d(-177px, 22px, 0px); top: 0px; left: 0px; will-change: transform',
                            border: '1px solid rgba(199, 199, 199, 0.15)'
                        }}
                    >
                        <p className="dropdown-item mb-0" style={{ cursor: 'pointer' }} onClick={this.onClickItems.bind(this, 'Edit')}>
                            {T.t('r_fileUpload_edit')}
                        </p>
                        <p className="dropdown-item text-danger mb-0" style={{ cursor: 'pointer' }} onClick={this.deleteMessageOnClick}>
                            {T.t('r_gen_delete_message')}
                        </p>
                    </div>
                </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IProcessingForumMessage): IProcessingForumMessage => {
    if (!state) {
        return ownProps;
    }

    const newProps: IProcessingForumMessage = Object.assign({}, ownProps, {
        forumSubject: state.forum.forumMessageSubject,
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CMessageProcessing = connect(
    mapStateToProps,
    dispatchProps
)(MessageProcessing);

export default CMessageProcessing;
